<template>
  <div :style="containerStyles">
    <code v-html="code" :style="styles"></code>
  </div>
</template>

<script>
import jsonViewer from './JsonViewer'
const parser = new jsonViewer()
/**
   * this template display your template scope variables in formatted json  (ex: var_dump)
   * @example
   * {{> json data={} listen=subscribeFn }}
   */

export default {
  name: 'jsonView',
  props: {
    data: { required: true },
    styles: { type: String, default: '' },
    containerStyles: {type: String, default: ''},
    additionData: { type: Object }
  },
  data () {
    return {
      code: ''
    }
  },
  created () {
    if (this.data) {
      let higherValues = []
      let lowerValues = []
      if(this.additionData) {
        _.map(this.data, (data,key) => {
          if(data > this.additionData[key]){
            higherValues.push(key)
          } else if (data < this.additionData[key]) {
            lowerValues.push(key)
          }
        })
      }
      parser.options.higherValues = higherValues
      parser.options.lowerValues = lowerValues

      this.code = parser.parse(this.data)
    }
  },
  watch: {
    data (prev, next) {
      if (!_.isEqual(prev, next)) this.code = parser.parse(this.data)
    }
  }
}
</script>

<style scoped>
    code {
        /* overflow: hidden; */
    }
</style>



// WEBPACK FOOTER //
// src/components/json/jsonView.vue